import { useEffect } from "react";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { useCartStore } from "@/stores/cart";

/**
 * Listens to Supabase auth state changes and clears the cart on logout.
 * Mount once in the app layout (e.g. inside App or a global provider).
 *
 * Privacy: on shared devices (common in Senegal), the previous user's
 * cart must not leak to the next user.
 */
export function useCartAuth() {
  const clearCart = useCartStore((s) => s.clearCart);

  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_OUT") {
        // Skip cart toast on admin pages — cart logic is storefront-only
        const isAdminRoute = window.location.pathname.startsWith("/admin");
        if (isAdminRoute) return;

        clearCart();
        toast.info("Panier vidé", {
          description: "Votre panier a été réinitialisé après la déconnexion.",
        });
      }
    });

    return () => subscription.unsubscribe();
  }, [clearCart]);
}
